import React from "react";
import { Table as SemanticTable } from "semantic-ui-react";
import { ClearableCheckboxDropdown, Table } from "dyl-components";
import { useSearchParams } from "react-router-dom";

const InvoicesTabTableHeader = ({ onFilter }) => {
    const [params] = useSearchParams();
    return (
        <Table.Row>
            <SemanticTable.HeaderCell>
                
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell width={2}>
                Invoice Date
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell width={2}>
                Due On
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell className="OrderInvoicesTable__InvoiceIDColumn">
                Invoice ID
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell>
                Billed Amount
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell>
                <ClearableCheckboxDropdown
                    text="Billed"
                    name="billed"
                    options={[
                        { key: "one-time", value:"one-time",  text: "One-time" }, 
                        { key: "monthly", value: "monthly", text: "Monthly" }, 
                        { key: "quarterly", value: "quarterly", text: "Quarterly" }, 
                        { key: "semi-annually", value: "semi-annually", text: "Semi-Annually" }, 
                        { key: "annually", value: "annually", text: "Annually" }
                    ]}
                    onChange={(_, { name, value }) => {
                        onFilter(_, { name, value });
                    }}
                    value={params.get("billed")?.split(",")}
                    closeOnLoad
                />
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell>
                <ClearableCheckboxDropdown
                    text="Payment Method"
                    name="payment_type"
                    options={[
                        {
                            key: 'none', value: 'none', text: 'None'
                        },
                        {
                            key: 'credit_card', value: 'credit_card', text: 'Credit Card'
                        },
                        {
                            key: 'debit_card', value: 'debit_card', text: 'Debit Card'
                        },
                        {
                            key: 'e-check', value: 'e-check', text: 'E-Check'
                        },
                        {
                            key: 'other', value: 'other', text: 'Other'
                        }
                    ]}
                    onChange={(_, { name, value }) => {
                        onFilter(_, { name, value });
                    }}
                    value={params.get("payment_type")?.split(",")}
                    closeOnLoad
                />
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell>
                <ClearableCheckboxDropdown
                    text="Invoice Status"
                    name="invoice_status"
                    options={[
                        {
                            key: 'open', value: 'open', text: 'Open'
                        },
                        {
                            key: 'paid', value: 'paid', text: 'Paid'
                        },
                        {
                            key: 'void', value: 'void', text: 'Void'
                        }
                    ]}
                    onChange={(_, { name, value }) => {
                        onFilter(_, { name, value });
                    }}
                    value={params.get("invoice_status")?.split(",")}
                    closeOnLoad
                />
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell>
                Actions
            </SemanticTable.HeaderCell>
        </Table.Row>
    );
};

export default InvoicesTabTableHeader;
